import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSurveyInProgress = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.63757 0.169739V1.76974C13.1743 2.20174 15.6798 5.39374 15.2448 8.90574C15.0669 10.3209 14.419 11.6368 13.4034 12.6453C12.3879 13.6537 11.0627 14.2971 9.63757 14.4737V16.0737C14.0685 15.5937 17.2508 11.6417 16.7674 7.24974C16.3485 3.52174 13.3918 0.569739 9.63757 0.169739ZM8.02631 0.169739C6.44727 0.313739 4.95686 0.929739 3.7323 1.92974L4.88435 3.16174C5.78666 2.44174 6.87426 1.97774 8.02631 1.81774V0.169739ZM2.59636 3.10574C1.58541 4.31744 0.965035 5.80319 0.815918 7.36974H2.42718C2.58025 6.23374 3.0314 5.15374 3.74841 4.24974L2.59636 3.10574ZM0.823974 8.96974C0.9851 10.5377 1.60544 12.0177 2.60442 13.2337L3.74841 12.0897C3.03691 11.1855 2.58336 10.1078 2.43523 8.96974H0.823974ZM4.85213 13.2657L3.7323 14.3617C4.9528 15.3717 6.44676 16.0007 8.02631 16.1697V14.5697C6.8802 14.4227 5.795 13.9723 4.88435 13.2657H4.85213Z",
		fill: "#F18832"
	})
});
export default SvgSurveyInProgress;
